import { createTheme } from "@mui/material/styles";

const customTheme = createTheme({
  components: {
    //IconButton SVG tag material icon
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: "4rem",
          color: "#ff4d5a",
          transition: "1s",
          "&:hover": {
            // color: props.color || "#08FDD8", //pass props to createTheme
            color: "#08FDD8",
            transform: "rotateY(360deg)",
          },
        },
      },
    },
    //Tooltips
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: "1.5rem",
          color: "#AAAAAA",
          backgroundColor: "rgb(42, 42, 42)",
        },
      },
    },

    //AlertTitle
    MuiAlertTitle: {
      styleOverrides: {
        root: {
          fontSize: "2rem",
        },
      },
    },

    //Alert Notification
    MuiAlert: {
      styleOverrides: {
        root: {
          fontSize: "1.5rem",
          backgroundColor: "rgb(42, 42, 42)",
        },
        filledSuccess: {
          color: "#08FDD8",
        },
        filledWarning: {
          color: "#ff4d5a",
        },
      },
    },

    //END Components
  },
});

export default customTheme;
